module.exports = __webpack_public_path__ + "img/1-consultor.020f1ddb.png";